import { WebStorageStateStore } from 'oidc-client';
import Config from 'services/config/local';

const origin = window.location.origin;

export default {
    ...Config.auth.openid,
    redirect_uri: `${origin}/auth/process`,
    silent_redirect_uri: `${origin}/silent.html`,
    post_logout_redirect_uri: `${origin}/`,
    userStore: new WebStorageStateStore({
        store: window.localStorage
    })
};
